import { all, call, select } from 'typed-redux-saga';

import { selectIsMeetingRoomIntegration, selectIsTeleMessenger } from '../../../shared/features/config/selectors';
import { isInsideIframe } from '../../../shared/helpers/iframe';
import { getMessageHandlerKind, MessageHandlerKind } from './get-message-handler-kind';
import { handleConferenceStatus } from './handle-conference-status';
import { handleConnection } from './handle-connection';
import { handleTeleMessengerMessage } from './handle-telemessenger-message';
import { handleUiStateSync } from './handle-ui-state-sync';
import { handleErrors } from './handleErrors';
import { handleMeetingRoomMessage } from './handleMeetingRoomMessage';
import { handleMessage } from './handleMessage';
import { syncMediaDevices } from './syncMediaDevices';
import { watchMessages } from './watchMessages';

/**
 * Рутовая сага звонков в режиме iframe
 */
export function* rootIframeSaga(): Generator {
    if (NODE || !isInsideIframe()) {
        return;
    }

    const isMeetingRoomIntegration = yield* select(selectIsMeetingRoomIntegration);
    const isTeleMessenger = yield* select(selectIsTeleMessenger);

    const getMessageHandler = () => {
        const messageHandlerKind = getMessageHandlerKind({ isMeetingRoomIntegration, isTeleMessenger });

        switch (messageHandlerKind) {
            case MessageHandlerKind.MeetingRoom:
                return handleMeetingRoomMessage;
            case MessageHandlerKind.TeleMessenger:
                return handleTeleMessengerMessage;
            default:
                return handleMessage;
        }
    };
    const messageHandler = getMessageHandler();

    yield* all([
        call(watchMessages, messageHandler),
        call(handleErrors),
        call(handleConnection),
        call(syncMediaDevices),
        call(handleUiStateSync),
        call(handleConferenceStatus),
    ]);
}
